import React from "react";
import styles from "./Styles.module.scss";
import cx from "classnames";
import isEqual from "is-equal";

import _ from 'lodash';
import UserGroupOptionView from "./options/index";
import UserGroupTagView from "./value/index";

import Select from 'react-select';

class UserGroupsAutoCompleteView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: [],
      options: [],
      cancel: false
    };

    this.populateOptions = this.populateOptions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCreateTag = this.handleCreateTag.bind(this);
    this.handleOnClose = this.handleOnClose.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.clearRenderer = this.clearRenderer.bind(this);
    
  }

  componentDidMount() {
    this.props.searchUserGroupForAutoComplete("", true);

    if (this.props.userGroups) {
      var options = this.populateOptions(this.props.userGroups);
      this.setState({
        options: options,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    var newOptions = this.populateOptions(nextProps.userGroups);

    if (newOptions.length > 0 && !isEqual(this.state.options, newOptions)) {
      this.setState({
        options: newOptions,
      });
    }
    if(_.size(nextProps.groups) == 0){
      this.setState({
        tags: []
      })
    }
  }

  handleReset() {
    this.setState({
      tags: [],
      options: [],
    });
  }

  clearRenderer(){
    this.setState({
      tags: []
    })
   }


  populateOptions(userGroups) {
    var options = (userGroups || [])
      .filter((userGroup) => {
        if (this.state.tags) {
          var index = this.state.tags.findIndex((tag) => {
            return tag.value == userGroup.name;
          });

          return index == -1;
        }

        return true;
      })
      .map((userGroup) => {
        return {
          value: userGroup,
          label: userGroup.name,
        };
      });

    return options;
  }

  handleChange(inputValue) {
    this.props.searchUserGroupForAutoComplete(inputValue, true);
    return inputValue;
  }

  handleCreateTag(selectedOptions) {
    if (!Array.isArray(selectedOptions)) {
      selectedOptions = [selectedOptions];
    }

    var newTags = selectedOptions
      .map((option) => {
        if (option.value === "") {
          return null;
        }

        return {
          label: option.option.label,
          value: option.option.value,
        };
      })
      .filter((tag) => tag != null);

    var combinedTags = [...this.state.tags, ...newTags];
    var uniqueTags = Array.from(
      new Set(combinedTags.map((tag) => tag.value.id))
    ).map((id) => {
      return combinedTags.find((tag) => tag.value.id === id);
    });

    var groupIds = uniqueTags.map((tag) => tag.value.id);

    this.setState({
      tags: uniqueTags,
      options: [],
    });

    this.props.onChange(groupIds);
  }

  handleOnClose() {
    this.props.invalidateAutoCompleteUserGroup();
  }

  handleDelete(option) {
    const updatedTags = this.state.tags.filter(
      (tag) => tag.value.id != option.value.id
    );
    this.setState({
      tags: updatedTags,
    });
  }

  getStyles() {
    return {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: '$secondary-background-color',
        border: state.isFocused ? 0 : 0,
        boxShadow: state.isFocused ? 0 : 0,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#333",
        fontSize: "0.75rem",
        transform: "none",
        position:"relative",
        top:"0.625rem",
      }),
      menuList: (base) => ({
        ...base,
        backgroundColor: '$secondary-background-color',
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        display: "none",
      }),
      input: (base) => ({
        ...base,
        position:"relative",
        top:"0.5rem",
      }),
      multiValue: (base, state) => ({
        ...base,
        backgroundColor: '$secondary-background-color',
      }),
      multiValueRemove: (base, { data }) => ({
        ...base,
        display: "none",
      }),
    };
  }

  render() {
    return (
      <div className={cx(styles.sectionsList, this.props.className)}>
        <Select
          arrowRenderer={null}
          isMulti={true}
          isLoading={this.props.loading && false}
          options={this.state.options}
          value={this.state.tags}
          components={{
            Option: (props) => <UserGroupOptionView {...props} />,
            ClearIndicator: () => (
              <ClearRenderer clearValue={this.clearRenderer} />
            ),
          }}
          styles={this.getStyles()}
          formatOptionLabel={(option) => (
            <UserGroupTagView option={option} onRemove={this.handleDelete} />
          )}
          onChange={(e) => this.handleCreateTag(e)}
          placeholder={this.props.placeholder}
          onInputChange={(e) => this.handleChange(e)}
          isClearable={false}
          backspaceRemovesValue={true}
          noOptionsMessage={() => null}
        />
      </div>
    );
  }
}

const ClearRenderer = ({ clearValue }) => (
  <div className="clear-indicator" onClick={clearValue}>
    &#x2715; {/* This is the 'x' symbol for clear */}
  </div>
);

export default UserGroupsAutoCompleteView;
